<template>
    <div v-if="!state.loading">
        <h2>{{page.title}} <br/>
            <small>(Submitted by {{page.name}})</small>
        </h2>
        <div class="writearea">
            <div class="qwrap" v-for="(row, rowIndex) in list" :key="rowIndex">
                <p class="qid">Question {{row.sn}}</p>
                <div class="ques" v-html="row.question"></div>
                <p class="anshd">Answer</p>
                <div class="ans" v-html="row.ans"></div>
                <input 
                    v-model="qmark[row.id]"
                    type="text" 
                    placeholder="Insert score here (total is 10 marks)"
                    class="answer"
                />
            </div>
        </div>
        <button class="btn-primary" @click="submitMarkings">
            Submit Markings
        </button>
    </div>
    <div v-else class="loader">
        <img src="@/assets/img/ajldr.gif" />
    </div>
</template>
<script>
import call from "../composables/call.js";
import { urls } from "../assets/js/urls.js";
import { onMounted, reactive, computed,ref} from 'vue';
import { useRoute, useRouter } from "vue-router";

export default {
    name:"AssignmentMarking",
    setup(){
        const qmark=ref({})
        const route = useRoute();
        const id = computed(() => route.params.id)
        const stu = computed(() => route.params.stu)
        const page=reactive({title:"",name:""});
        const state=reactive({loading:true})
        const list = ref([])
        const router = useRouter();

        function setTable(d){
            if (!Array.isArray(d)) {
                list.value = Object.values(d)
            } else {
                list.value = d
            }
        }
        
        onMounted(() => {
            call({
                url:urls.subject,
                data:{getStudentAssignmentAnswers:id.value,student:stu.value},
                success:(res)=>{
                    state.loading=false
                    if(res.status){
                        page.title=res.msg.title;
                        page.name=res.msg.name;
                        setTable(res.msg.list)
                    }else{
                        alert(res.msg);
                    }
                }
            })
        });

        function submitMarkings(){
            const data={"markAssignment":id.value,"markings":qmark.value}
            state.loading=true;
            call({
                url:urls.subject,
                data:data,
                success:(res)=>{
                    state.loading=false;
                    if(res.status){
                        alert(res.msg)
                        router.push({ name: 'submissionlist', params:{id: id.value} });
                    }else{
                        alert(res.msg)
                    }
                }
            })
        }

        return {page, state,list, qmark,submitMarkings}
    }
}
</script>

<style>
h2{font-size: 22px; line-height: 1em;}
h2 small{color: #3c8dbc;}
.qwrap{margin-bottom:10px; background: white; padding: 15px 10px; 
    border-radius: 15px; font-size: 15px;}
.writearea{margin-top:15px}
.answer{background: #ebebeb; padding: 15px; margin-top: 10px;}
.qid, .anshd{font-weight:bold; margin: 0;}
.ques{margin:0}
.ans{font-size:14px}
</style>